import { compose } from 'recompose';

export default compose();
